import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { JSONEditor } from '@json-editor/json-editor';
import '@json-editor/json-editor/src/style.css';
import * as utilities from '../utilities';

const EquipmentChecklistConfig = (props) => {

  const editorRef = useRef(null);
  const [resultConfig, setResultConfig] = useState({});
  // const [initialConfig, setInitialConfig] = useState({});
  const [isLoaded, setIsLoaded] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const fetchConfig = async () => {
    const response = await fetch(props.configLink + '/?rawdata=true', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + utilities.getAccessToken()
      }
    })

    if (response.ok) {
      const result = await response.json();
      setResultConfig(JSON.parse(result.config));
      // setInitialConfig((result.config));
    } else {
      utilities.addToast('Unable to load configuration', 5, 'danger');
    }

  };

  const saveConfig = async () => {
    const response = await fetch(props.configLink, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + utilities.getAccessToken()
      },
      body: (resultConfig)
    })
    if (response.ok) {
      utilities.addToast('Configuration saved', 5, 'success');
      setIsSaving(false);
    } else {
      utilities.addToast('Unable to save configuration', 5, 'danger');
      setIsSaving(false);
    }
  };

  useEffect(() => {
    fetchConfig();
  }, [])

  useEffect(() => {

    if (Object.keys(resultConfig).length === 0 || isLoaded) return;

    // Define your JSON schema
    const schema = {
      type: "object",
      title: " ",
      id: "settings",
      options: {
        "disable_properties": true,
        "disable_collapse": true
      },
      "properties": {
        "EquipmentName": {
          "type": "array",
          "format": "table",
          "options": {
            "collapsed": true,
            "disable_array_delete_all_rows": true,
            "disable_array_delete_last_row": true
          },
          "title": "Equipment Name",
          "uniqueItems": true,
          "items": {
            "type": "string",
            "title": "Name"
          }
        }
      }
    }

    // Create JSON Editor instance
    const editor = new JSONEditor(editorRef.current, {
      schema,
      disable_edit_json: true
      // theme: 'html',
      // iconlib: "fontawesome4"
    });

    editor.on('change', () => {
      setResultConfig(JSON.stringify(editor.getValue()))
      // setShowSaveButton(true);
    });

    setIsLoaded(true);

    editor.on('ready', () => {
      editor.setValue(resultConfig);
    });

  }, [resultConfig]);

  return (
    <Container fluid className='mt-4'>
      <Row className='m-0 p-0 align-items-end '>
        <Col xs={4} className='m-0 p-0 pe-3'>
          <Row>
            <Col className='m-0'>
              <img id="logo" src={props.logo} alt={props.title} onClick={props.onLogoClick} />
            </Col>
          </Row>
        </Col>
        <Col className='text-end'>
          <Button
            color="success"
            disabled={isSaving}
            onClick={() => {
              setIsSaving(true);
              saveConfig()
            }}>
            Save
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <div id="config" ref={editorRef}></div>
        </Col>
      </Row>
    </Container>
  );
};

export default EquipmentChecklistConfig;
